import React, { useContext, useEffect, useState } from "react"
import SubmitButton from "../../../SubmitButton"
import { SpaceProfileContext } from "../../context"
import api from "../../../../utils/api"
import { differenceInMinutes, format } from "date-fns"
import LinkToReservationStep from "./LinkToReservationStep"
import countWorkingDays from "../../../../utils/countWorkingDays"
import * as s from "./index.module.less"

const OnDemandOptions = () => {
  const {
    commonData: {
      contextDate,
      contextEndDate,
      startTime,
      endTime,
      teamSize,
      isDaily,
      data,
      profileFilterProgress,
      holidays,
      hstPercentage,
      filteredOptions,
    },
    actions: { setValue },
  } = useContext(SpaceProfileContext)

  const [initialDataLoaded, setIdl] = useState(false)

  const [newSearch, setNewSearch] = useState(false)

  useEffect(() => {
    setNewSearch(true)
    if (
      profileFilterProgress ||
      filteredOptions.length > 0 ||
      initialDataLoaded
    )
      return
    if (teamSize || contextDate) setIdl(true)
    checkAvailability()
  }, [teamSize, contextDate])

  const checkAvailability = async () => {
    if (!teamSize || !contextDate) {
      return
    }
    setIdl(true)
    setValue({ profileFilterProgress: true })

    await api("search/on-demand-spaces", {
      location_id: data ? data.id : null,
      results_count: 2,
      params: {
        team_size: teamSize || 1,
        on_demand_type: isDaily ? "Daily" : "Hourly",
        start_date: contextDate ? format(contextDate, "yyyy-MM-dd") : null,
        end_date: contextEndDate
          ? format(contextEndDate, "yyyy-MM-dd")
          : contextDate
            ? format(contextDate, "yyyy-MM-dd")
            : null,
        start_time: startTime ? format(startTime, "h:mm a") : null,
        end_time: endTime ? format(endTime, "h:mm a") : null,
      },
    })
      .then((res) => {
        setNewSearch(false)
        const dateDifference = isDaily
          ? countWorkingDays(contextDate, contextEndDate, holidays)
          : differenceInMinutes(endTime, startTime) / 60
        const days = isNaN(dateDifference) ? 1 : dateDifference
        const optionPrice =
          res.data.offices.length > 0
            ? isDaily
              ? res.data.offices[0].price_per_day
              : res.data.offices[0].price_per_hour
            : 0
        const optionValue = optionPrice * days
        const optionHstValue = optionValue * hstPercentage

        setValue({
          profileFilterProgress: false,
          filteredOptions: res.data.offices,
          optionId: res.data.offices.length > 0 ? res.data.offices[0].id : null,
          optionPrice: Number(optionPrice),
          optionValue: Number(optionValue),
          optionHstValue: Number(optionHstValue),
          optionData:
            res.data.offices.length > 0
              ? res.data.offices[0]
              : { price_per_hour: 0, price_per_day: 0 },
          optionTotal: Number(optionValue + optionHstValue),
          days,
        })
      })
      .catch((e) => {
        console.log(e)
      })
    setValue({ profileFilterProgress: false })
  }

  const isDailyInactive = !teamSize || !contextDate
  const isHourlyInactive = !teamSize || !contextDate || !startTime || !endTime

  if (filteredOptions.length === 0) {
    return (
      <>
        {!profileFilterProgress && (
          <>
            {!teamSize || !contextDate ? (
              <div className={s.results_wrapper}>
                <p>Please select team size and dates to get started.</p>
              </div>
            ) : (
              <>
                {newSearch ? (
                  ""
                ) : (
                  <div className={s.results_wrapper}>
                    <p>
                      No results. Try adjusting your team size or your dates.{" "}
                    </p>
                  </div>
                )}
              </>
            )}
          </>
        )}
        <SubmitButton
          label={"Check Availability"}
          progress={profileFilterProgress}
          disabled={isDaily ? isDailyInactive : isHourlyInactive}
          onClick={checkAvailability}
        />
      </>
    )
  }

  return (
    <>
      <LinkToReservationStep />
    </>
  )
}

export default OnDemandOptions
